<p-tabs [value]="selectedTab" (valueChange)="selectedTab = $event">
    @if (showTabs()) {
        <p-tablist>
            <p-tab value="message">{{ 'messages.message' | translate }}</p-tab>
            <p-tab value="read">{{ 'messages.read' | translate }}</p-tab>
        </p-tablist>
    }
    <p-tabpanels>
        <p-tabpanel value="message">
            <app-message-recipient-detail-page #detail [id]="id"></app-message-recipient-detail-page>
        </p-tabpanel>
        @if (showTabs() && messageId() !== null) {
            <p-tabpanel value="read">
                <app-message-recipients-table [messageId]="messageId()!"></app-message-recipients-table>
            </p-tabpanel>
        }
    </p-tabpanels>
</p-tabs>

<div #dialogFooter></div>
